export enum ErrorTitleEnum {
    ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
    BIOMETRY_ERROR = 'BIOMETRY_ERROR',
    STATUS_INVALID = 'STATUS_INVALID',
    STEP_INVALID = 'STEP_INVALID',
    STEP_TOKEN_INVALID = 'STEP_TOKEN_INVALID',
    STEP_TOKEN_EXPIRED = 'STEP_TOKEN_EXPIRED',
    SECURITY_PROPOSAL_DENIED = 'SECURITY_PROPOSAL_DENIED',
    SECURITY_EMAIL_INVALID = 'SECURITY_EMAIL_INVALID',
    SECURITY_BIO_RETRY = 'SECURITY_BIO_RETRY',
    STEP_KIT_INVALID = 'STEP_KIT_INVALID',
    STEP_KIT_CODE_INVALID = 'STEP_KIT_CODE_INVALID',
    GDD_UPLOAD_DOC_LIST_CFT = 'GDD_UPLOAD_DOC_LIST_CFT',
    INTEGRATION_MSG = 'INTEGRATION_MSG',
    INTEGRATION_OSA = 'INTEGRATION_OSA',
    INTEGRATION_PE = 'INTEGRATION_PE',
    INTEGRATION_GDD = 'INTEGRATION_GDD',
    INTEGRATION_TH = 'INTEGRATION_TH',
    INTEGRATION_BG = 'INTEGRATION_BG',
    INTEGRATION_BW = 'INTEGRATION_BW',
    INTEGRATION_SM = 'INTEGRATION_SM',
    DEFAULT_ERROR = 'DEFAULT_ERROR',
    STEP_INVALID_CREDENTIONS = 'STEP_INVALID_CREDENTIONS',
    STEP_HAS_RESTRICTIVE = 'STEP_HAS_RESTRICTIVE',
    STEP_PROPOSAL_DENIED = 'STEP_PROPOSAL_DENIED',
    STEP_ACCOUNT_HOLDER = 'STEP_ACCOUNT_HOLDER',
    DEFAULT_WARNING = 'Atenção!',
}

export enum ErrorMessageEnum {
    DEFAULT_ERROR = "Não foi possível completar a operação.",
    ENTITY_NOT_FOUND = 'Proposta não encontrada.',
    STATUS_INVALID = 'Essa proposta está em um status inválido.',
    STEP_INVALID = 'A proposta não está nessa fase do cadastro.',
    STEP_TOKEN_INVALID = 'O token informado é diferente do token enviado.',
    STEP_TOKEN_EXPIRED = 'O token utilizado está expirado. Necessário envio de um novo token.',
    SECURITY_PROPOSAL_DENIED = 'Essa proposta não pode seguir, foi negada.',
    SECURITY_EMAIL_INVALID = 'O e-mail informado é inválido.',
    SECURITY_BIO_RETRY ='Biometria não aprovada, é necessário tentar nova captura.',
    STEP_KIT_INVALID ='O código do kit é inválido.',
    STEP_KIT_CODE_INVALID ='O código do kit está incorreto.',
    INTEGRATION_MSG = 'Erro na comunicação com o serviço de mensageria. ',
    INTEGRATION_OSA = 'Erro na comunicação com o OSA.',
    INTEGRATION_PE = 'Erro na comunicação com o PERSONAS.',
    INTEGRATION_GDD = 'Erro na comunicação com a PASTA DIGITAL.',
    INTEGRATION_TH ='Erro na comunicação com o TH.',
    INTEGRATION_BG= 'Erro na comunicação com o BG.',
    INTEGRATION_BW='Erro na comunicação com o BW.',
    INTEGRATION_SM ='Erro na comunicação com o SM.',
    AWAITING_PROPOSAL_DENIED='Erro ao fazer bypass de antifraude.',
    unknownError='Erro desconhecido.',
    UNAUTHORIZED = 'Unauthorized',
    INVALID_TOKEN_TYPE = 'Invalid token type',
    INVALID_TOKEN = 'Invalid token',
    JWT_EXPIRED = 'JWT expired',
    JWT_INVALID = 'JWT Sequence Invalid',
    CREDENTIALS_MUST_BE_PROVIDED = 'Credentials must be provided'
   }

   export enum ErrorTypeEnum {
    TOKEN = 'token',
    RETRY = 'retry'
}
